import { render, staticRenderFns } from "./AlertInformationForm.vue?vue&type=template&id=65185500&scoped=true&"
import script from "./AlertInformationForm.vue?vue&type=script&lang=js&"
export * from "./AlertInformationForm.vue?vue&type=script&lang=js&"
import style0 from "./AlertInformationForm.vue?vue&type=style&index=0&id=65185500&scoped=true&lang=css&"
import style1 from "./AlertInformationForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65185500",
  null
  
)

export default component.exports